<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0">
      <div class="actions-left col-lg-6 row p-0 m-0">
       <span class="col-lg-6 m-0 p-0 text-left"> 
         <button v-bind:class="{'font-weight-bold': status == ACTIVE_STATUS}" class="status-button" @click="status = ACTIVE_STATUS">{{ $t('active') }}</button> <span  v-bind:class="{'font-weight-bold': status == ACTIVE_STATUS}">({{activeCount}})</span> | <button v-bind:class="{'font-weight-bold': status == ARCHIVE_STATUS}" class="status-button" href="#" @click="status = ARCHIVE_STATUS">{{ $t('archive') }}</button> <span v-bind:class="{'font-weight-bold': status == ARCHIVE_STATUS}">({{archiveCount}})</span>
       </span>
      </div>
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary" @click="addPost">{{ $t('add') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover striped :caption="caption" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from '@/controls/PaginatedTable.vue'
import SearchBar from '@/controls/SearchBar.vue'
import router from '@/router';
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import { convertToPascalCase, formatDateTime } from "@/helpers/utils.js";

const ARCHIVE_STATUS = false;
const ACTIVE_STATUS = true;

export default {
  components: { CTableWrapper, SearchBar },
  data () {
    return {
      status: '',
      searchText: '',
      caption: i18n.t('posts'),
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'createdAt', label: i18n.t('createdAt'), sortable: true },
        { key: 'title', label: i18n.t('title'), _classes: 'font-weight-bold', sortable: true },
      ],
      actions: [],
      sorterValue: { column: 'id', asc: true },
      loading: false,
      // Provide access to consts on HTML
      ARCHIVE_STATUS: ARCHIVE_STATUS,
      ACTIVE_STATUS: ACTIVE_STATUS
    }
  },
  computed: {
    ...mapState('posts', ['getPostsOutput']),
    ...mapState('posts', ['putPostChangeStatusByIdOutput']),
    postInfo: function() {
      return this.getPostsOutput && this.getPostsOutput.data ? this.getPostsOutput.data : null;
    },
    items: function()
    {
      var result = [];

      if(this.postInfo && this.postInfo.data)
      {
        result = this.postInfo.data;
        result.forEach(order => 
        { 
          order['createdAt'] = formatDateTime(order.createdAt);
        });
      }

      return result;
    },
    activeCount: function()
    {
      return this.postInfo ? this.postInfo.visible : 0;
    },
    archiveCount: function()
    {
      return this.postInfo ? this.postInfo.notVisible : 0
    },
    pages: function()
    {
      return this.postInfo ? this.postInfo.totalPages : 1;
    },
  },
  mounted: function()
  {
    this.status = ACTIVE_STATUS;
  },
  methods: {
    ...mapActions('posts', ['getPosts']),
    ...mapActions('posts', ['putPostChangeStatusById']),
    rowClicked (item) {
        this.$router.push({ name: "PostEdit", query: { id: item.id }, params: { name: item.name } });
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        {
          this.$router.push({ name: "PostEdit", query: { id: item.id }, params: { name: item.name } });
          break;
        }
        case 'disable':
        {
          if(confirm(this.$i18n.tc('confirmDisable', item.title, { name: item.title }))){
            this.putPostChangeStatusById(item.id);
          }
          break;
        }
        case 'enable':
        {
          if(confirm(this.$i18n.tc('confirmEnable', item.title, { name: item.title }))){
            this.putPostChangeStatusById(item.id);
          }
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {
      //Make request
      this.loading = true;
      this.itemsPerPage = itemsPerPage;

      var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column), this.status);
      this.getPosts(input); 
    },
    addPost () 
    {
      router.push({name: "PostAdd", params: { type: this.$route.params.type } });
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    }    
  },
  watch:
  {
    status: function (val) {
      // Update actions
      switch(val) {

        case ACTIVE_STATUS:
        {
          this.actions = [];        
          this.actions.push({ key: 'view', label: this.$i18n.t("view") });
          this.actions.push({ key: 'disable', label: this.$i18n.t("disable") });
          
          break;
        }
        case ARCHIVE_STATUS:
        {
          this.actions = [];
        
          this.actions.push({ key: 'view', label: this.$i18n.t("view") });
          this.actions.push({ key: 'enable', label: this.$i18n.t("enable") });

          break;
        }
        default:
        {
          throw "The provided status is not supported!"; 
        }
      }

      // Update items
      this.$refs.table.reset();
      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    putPostChangeStatusByIdOutput: function(val)
    {
      this.loading = true;
      if(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    getPostsOutput: function(val)
    {
      this.loading = false;
    }
  }
}
</script>